/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PriceSettingsUpdateDto
 */
export interface PriceSettingsUpdateDto {
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsUpdateDto
     */
    priceUnitId: number;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsUpdateDto
     */
    listPriceFmcFactorTarget?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsUpdateDto
     */
    localLeadFxRate?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsUpdateDto
     */
    alternativeFxRate?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsUpdateDto
     */
    thresholdBelowMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsUpdateDto
     */
    thresholdBelowMax?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsUpdateDto
     */
    thresholdPrice?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsUpdateDto
     */
    thresholdAboveMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsUpdateDto
     */
    thresholdAboveMax?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsUpdateDto
     */
    alternativeSalesDiscount?: number | null;
    /**
     * 
     * @type {number}
     * @memberof PriceSettingsUpdateDto
     */
    alternativeFunctionalDiscount?: number | null;
}

/**
 * Check if a given object implements the PriceSettingsUpdateDto interface.
 */
export function instanceOfPriceSettingsUpdateDto(value: object): value is PriceSettingsUpdateDto {
    if (!('priceUnitId' in value) || value['priceUnitId'] === undefined) return false;
    return true;
}

export function PriceSettingsUpdateDtoFromJSON(json: any): PriceSettingsUpdateDto {
    return PriceSettingsUpdateDtoFromJSONTyped(json, false);
}

export function PriceSettingsUpdateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PriceSettingsUpdateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'priceUnitId': json['priceUnitId'],
        'listPriceFmcFactorTarget': json['listPriceFmcFactorTarget'] == null ? undefined : json['listPriceFmcFactorTarget'],
        'localLeadFxRate': json['localLeadFxRate'] == null ? undefined : json['localLeadFxRate'],
        'alternativeFxRate': json['alternativeFxRate'] == null ? undefined : json['alternativeFxRate'],
        'thresholdBelowMin': json['thresholdBelowMin'] == null ? undefined : json['thresholdBelowMin'],
        'thresholdBelowMax': json['thresholdBelowMax'] == null ? undefined : json['thresholdBelowMax'],
        'thresholdPrice': json['thresholdPrice'] == null ? undefined : json['thresholdPrice'],
        'thresholdAboveMin': json['thresholdAboveMin'] == null ? undefined : json['thresholdAboveMin'],
        'thresholdAboveMax': json['thresholdAboveMax'] == null ? undefined : json['thresholdAboveMax'],
        'alternativeSalesDiscount': json['alternativeSalesDiscount'] == null ? undefined : json['alternativeSalesDiscount'],
        'alternativeFunctionalDiscount': json['alternativeFunctionalDiscount'] == null ? undefined : json['alternativeFunctionalDiscount'],
    };
}

export function PriceSettingsUpdateDtoToJSON(json: any): PriceSettingsUpdateDto {
    return PriceSettingsUpdateDtoToJSONTyped(json, false);
}

export function PriceSettingsUpdateDtoToJSONTyped(value?: PriceSettingsUpdateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceUnitId': value['priceUnitId'],
        'listPriceFmcFactorTarget': value['listPriceFmcFactorTarget'],
        'localLeadFxRate': value['localLeadFxRate'],
        'alternativeFxRate': value['alternativeFxRate'],
        'thresholdBelowMin': value['thresholdBelowMin'],
        'thresholdBelowMax': value['thresholdBelowMax'],
        'thresholdPrice': value['thresholdPrice'],
        'thresholdAboveMin': value['thresholdAboveMin'],
        'thresholdAboveMax': value['thresholdAboveMax'],
        'alternativeSalesDiscount': value['alternativeSalesDiscount'],
        'alternativeFunctionalDiscount': value['alternativeFunctionalDiscount'],
    };
}

